import { IRouteAlteration } from "src/app/models";

export function initialRouteAlterationCreate(): IRouteAlteration {
  return {
    name: '',
    startDateTime: null,
    endDateTime: null,
    active: true,
    informativeMessage: '',
    terrain: []
  }
}